import React from "react";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import Routers from "../routes";
const App = () => {
  return (
    <>
      <Helmet>
        <title>Search FM</title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <ToastContainer />
      <Routers />
    </>
  );
};

export default App;
